export enum Routes {
  Home = "home",
  Apis = "apis",
  Dashboard = "dashboard",
  Contracts = "contracts",
  Rules = "rules",
  NewContract = "new-contract",
  NewRule = "rules",
}
